export default __webpack_public_path__ + "static/media/sb-dropdown.06cff9af.webp";